import React from 'react';
import '../OurServicesDetail.css';

const OurServicesDetail4 = () => {
  const servicesData = [
    {
      id: 1,
      iconBg: '#1a237e',
      iconSymbol: '👥',
      title: 'Statutory, internal, and tax audits',
      description: 'Our expert consultants work with you to develop a comprehensive HR strategy aligned with your business goals.',
      subDescription: 'We assess your current HR'
    },
    {
      id: 2,
      iconBg: '#1a237e',
      iconSymbol: '📋',
      title: 'Complete audit lifecycle coordination and reporting',
      description: 'We ensure your HR policies and procedures are compliant with local labor laws and regulations. Our consultants review and update your employee handbook,'
    },
    {
      id: 3,
      iconBg: '#1a237e',
      iconSymbol: '⚙️',
      title: 'Add More +',
      description: 'XYZ +'
    },
    {
      id: 4,
      iconBg: '#1a237e',
      iconSymbol: '💻',
      title: 'Add More +',
      description: 'XYZ +'
    }
   
   
  ];

  return (
    <div className="hrservices-main-wrapper">
      {/* Hero Section */}
      <div className="hrservices-banner-section">
        <div className="hrservices-banner-content">
          <div className="hrservices-navigation-breadcrumb">
          </div>
          <h1 className="hrservices-main-heading">OUR SERVICE PORTFOLIO</h1>
          <h2>Audit & Assurance</h2>
        </div>
        <div className="hrservices-banner-visual">
          <div className="hrservices-professional-avatar"></div>
        </div>
      </div>

      {/* Services Grid */}
      <div className="hrservices-content-area">
        <div className="hrservices-cards-container">
          {servicesData.map((serviceItem) => (
            <div key={serviceItem.id} className="hrservices-individual-card">
              <div className="hrservices-card-icon-wrapper" style={{backgroundColor: serviceItem.iconBg}}>
                <span>{serviceItem.iconSymbol}</span>
              </div>
              <div className="hrservices-card-text-content">
                <h3 className="hrservices-card-heading">{serviceItem.title}</h3>
                <p className="hrservices-card-description">
                  {serviceItem.description}
                  {serviceItem.subDescription && (
                    <>
                      <br />
                      {serviceItem.subDescription}
                    </>
                  )}
                </p>
                <button className="hrservices-cta-button">
                  Read More
                  <span className="hrservices-button-arrow">→</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurServicesDetail4;